import { PaymentOptionsVm } from '../../payment-settings/classes/paymentOptions';
import { PaymentData } from './../classes/paymentData';
import { AppResponse } from 'modules/core/interfaces/appResponse';
import AuthorizedApiClient from 'modules/auth/models/authorizedApiClient';
import { AxiosResponse } from 'axios';
import { SubscriptionVm } from '../classes/subscriptionVm';
import store from '@/store/index';
import { CreatePaymentResponse } from '../classes/createPaymentResponse';
import { loadStripe, Stripe } from '@stripe/stripe-js';

export class PaymentsApi {
  public MasterAccountId: string;

  public constructor() {
    this.MasterAccountId = store.state.auth && store.state.auth.user
    ? store.state.auth.user.MasterAccountId
    : null;
  }

  public async getSubscriptionByCode(subscriptionCode: string): Promise<SubscriptionVm> {
    const response: AxiosResponse<
      AppResponse<SubscriptionVm>
    > = await AuthorizedApiClient.get('/subscription/GetSubscription?subscriptionCode=' + subscriptionCode);

    const appResponse: AppResponse<SubscriptionVm> = response.data;
    if (appResponse.IsSuccess) {
      return appResponse.Result;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

  public async pay(data: PaymentData): Promise<CreatePaymentResponse> {
    const response: AxiosResponse<
      AppResponse<CreatePaymentResponse>
    > = await AuthorizedApiClient.post('/payment/Create', data);

    const appResponse = response.data;
    
    if (appResponse.IsSuccess) {
      return appResponse.Result;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }

  public async getCards(): Promise<PaymentOptionsVm> {
    const response: AxiosResponse<
      AppResponse<PaymentOptionsVm>
    > = await AuthorizedApiClient.get('/payment/GetUserCards');

    const appResponse: AppResponse<PaymentOptionsVm> = response.data;
    if (appResponse.IsSuccess) {
      return appResponse.Result;
    } else {
      throw new Error(appResponse.ErrorCodes.join(','));
    }
  }
}
